<template>
  <div class="cover" v-if="problem">
    <img
      v-if="problem.coverMedia"
      style="width: 100%; height:300px; object-fit:cover"
      :src="prefix + problem.coverMedia"
      alt="şikayət şəkli"
    />
    <img v-else src="../../assets/imgs/no-file.png" style="width: 100%" />
    <div class="info">
      <div>№: {{ problem.number.pad(6) }}</div>
    </div>

    <div class="count">
      <a-icon type="usergroup-add" />
      {{ problem.appealCount ? problem.appealCount : problem.joinedCount }}
    </div>
  </div>
</template>

<script>
import { URL } from "@/utils/api";

export default {
  name: "ProblemCoverCol",
  props: { problem: Object },
  data() {
    return {
      prefix: URL[process.env.NODE_ENV].file_url,
    };
  },
};
</script>

<style lang="scss" scoped>
.cover {
  position: relative;

  & .count {
    position: absolute;
    top: 5px;
    left: 5px;
    background-color: rgba(0, 0, 0, 0.85);
    border-radius: 50%;
    color: white;
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & .info {
    position: absolute;
    width: 100%;
    bottom: 0;
    display: flex;
    flex-direction: row;
    background-color: rgba(0, 0, 0, 0.5);
    border-top: 1px solid white;
    display: flex;
    flex-direction: column;

    & div {
      text-align: center;
    }

    & div:first-child {
      border-right: 1px solid white;
    }

    & div {
      font-size: 16px;
      flex: 1;
      color: white;
      line-height: 36px;

      & .anticon {
        margin-right: 5px;
      }
    }
  }
}
</style>
